import axios, { AxiosResponse } from 'axios';

import { CustomerUrl } from '../../../../types';

import { EnableDisableSSORequest } from '../customer/customer.state';

import { ProfileResponse, ProfileState, TeamSettings } from './profile.state';

import Config from 'config';

class ProfileService {
  async getProfile(): Promise<AxiosResponse<ProfileState>> {
    return await axios.get<ProfileState>(`${Config.SERVER_URL}/customers/user`);
  }

  async updateProfile(data: any): Promise<AxiosResponse<ProfileState>> {
    return await axios.put<ProfileState>(`${Config.SERVER_URL}/customers/user`, data);
  }

  async uploadProfilePic(data: any): Promise<AxiosResponse<CustomerUrl>> {
    return await axios.post(`${Config.SERVER_URL}/customers/user/profile/upload`, data);
  }

  async enableDisableSSO(
    payload: EnableDisableSSORequest,
  ): Promise<AxiosResponse<ProfileResponse>> {
    return await axios.put<ProfileResponse>(`${Config.SERVER_URL}/customers/company`, payload);
  }

  async updateTeamSettings(payload: TeamSettings): Promise<AxiosResponse<TeamSettings>> {
    return await axios.patch<TeamSettings>(`${Config.SERVER_URL}/teams/teamSettings`, payload);
  }
}

export default new ProfileService();
